import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const contactSchema = z.object({
  name: z.string().trim().min(1).max(100),
  phone: z.string().trim().min(7).max(30),
  email: z.string().trim().email().max(255),
  service: z.string().trim().min(1).max(60),
  message: z.string().trim().max(1000).optional().or(z.literal("")),
});

export const submitContactRequest = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => contactSchema.parse(data))
  .handler(async ({ data }) => {
    const { sendTemplateEmail } = await import("@/lib/email-templates/send-email");

    const result = await sendTemplateEmail("contact-request", "thecrew1962@gmail.com", {
      templateData: {
        name: data.name,
        phone: data.phone,
        email: data.email,
        service: data.service,
        message: data.message ?? "",
      },
      idempotencyKey: `contact-request-${data.email}-${Date.now()}`,
      replyTo: data.email,
    });

    return { ok: true, sent: result.sent };
  });
